export interface GetAllNotifiche2023FiltersDTO {
    itemsPerPage: number
    page: number
    order?: boolean
    sort?: string
    headQuarters?: string
    notType?: string
    notSuperata?: boolean
}

export interface GetAllNotifiche2023ResponseDTO {
    itemsPerPage: number
    page: number
    total: number
    totalPage: number
    // data: GetAllNotifiche2023ResponseData[]
}

export interface GetAllNotifiche2023ResponseData {
    id: string
    company: string
    customerId: string,
    customerCompanyName: string,
    customerRegion: string,
    customerHeadQuarters: string,
    customerClientCode: string,
    startingDate: Date,
    endingDate: Date,
    notifications: GetAllNotifiche2023ResponseNotifications[]
    inspectionVisits: string
}

export interface GetAllNotifiche2023ResponseNotifications {
    id: string,
    identifier:string,
    releaseDate: Date,
    type: string
}


export enum NotTypeEnum {
    PRIMA_NOTIFICA = 'PRIMA_NOTIFICA',
    NOTIFICA_VARIAZIONE_ODC = 'NOTIFICA_VARIAZIONE_ODC',
    NOTIFICA_VARIAZIONE_ALTRO = 'NOTIFICA_VARIAZIONE_ALTRO',
    PRIMA_NOTIFICA_ODC = 'PRIMA_NOTIFICA_ODC',
}